import { transport } from 'config/transport';

export function callApiGetListOfDanhMucThu(congDoanId) {
    return transport.get(`/mamnon/${congDoanId}/thuhocsinh/danhmucthu`);
}
